import { render, staticRenderFns } from "./Contactbar.vue?vue&type=template&id=21bbde30&scoped=true&"
import script from "./Contactbar.vue?vue&type=script&lang=js&"
export * from "./Contactbar.vue?vue&type=script&lang=js&"
import style0 from "./Contactbar.vue?vue&type=style&index=0&id=21bbde30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbde30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VIcon,VImg,VOverlay,VProgressCircular,VSheet})
